import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getCommunes, toggleCommune } from '../../api/communes';
import { PageHeader } from '../../components/layout/PageHeader';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
const planColors = {
    starter: 'bg-gray-100 text-gray-700',
    standard: 'bg-blue-100 text-blue-700',
    premium: 'bg-purple-100 text-purple-700',
};
export default function CommuneList() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { data, isLoading } = useQuery({ queryKey: ['communes'], queryFn: () => getCommunes() });
    const toggleMutation = useMutation({
        mutationFn: (id) => toggleCommune(id),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['communes'] }),
    });
    const columns = [
        { key: 'name', header: 'Nom' },
        { key: 'slug', header: 'Slug', render: (c) => _jsx("code", { className: "text-xs bg-gray-100 px-1.5 py-0.5 rounded", children: c.slug }) },
        { key: 'postal_code', header: 'CP', render: (c) => c.postal_code ?? '-' },
        { key: 'plan', header: 'Plan', render: (c) => _jsx(StatusBadge, { status: c.plan, colorMap: planColors }) },
        { key: 'connectors', header: 'Connecteurs', render: (c) => {
                const types = Object.values(c.connectors ?? {}).map((v) => v.type).filter((t) => t && t !== 'none');
                return types.length > 0 ? types.join(', ') : 'Manuel';
            } },
        { key: 'active', header: 'Statut', render: (c) => (_jsx(StatusBadge, { status: c.active ? 'active' : 'inactive', colorMap: { active: 'bg-green-100 text-green-700', inactive: 'bg-red-100 text-red-700' } })) },
        { key: 'actions', header: '', render: (c) => (_jsx("button", { onClick: (e) => { e.stopPropagation(); toggleMutation.mutate(c.id); }, className: "text-xs text-gray-500 hover:text-gray-700", children: c.active ? 'Désactiver' : 'Activer' })) },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: "Communes", subtitle: `${data?.total ?? 0} commune(s)`, actions: _jsx("button", { onClick: () => navigate('/super-admin/communes/new'), className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700", children: "Nouvelle commune" }) }), _jsx(DataTable, { columns: columns, data: data?.data ?? [], isLoading: isLoading, onRowClick: (c) => navigate(`/super-admin/communes/${c.id}`) })] }));
}
